<ng-content select=".transclude-content"></ng-content>
<pru-modal [modalId]="modalId" size="modal-lg" [showClose]="false" modalScrollable="true" *ngIf="show2FaModal">
  <div modal-body class="white-space-wrap text-left pt-2"  [attr.data-qa]="'two-factor-modal'">
  <ng-container *ngIf="twoFactorAuthService.checkingHRT; else pruModal">
    <p class="text-center pt-3 pb-3 h2">Please Wait...<span class="fa fa-spinner fa-pulse fa-fw"></span></p>
  </ng-container>
  <ng-template #pruModal>
    <div class="row mt-4" [attr.data-qa]="'two-factor-modal-error-block'" *ngIf="twoFactorAuthService.serviceFail; else nonErrorBlock">
      <div class="col-xs-11 p-0 ml-3 mr-3" [attr.tabindex]="0" id="errorDiv" #errorDiv>
        <div class="alert alert-danger">
          <h3 class="h4">Error:</h3>
          <p> {{twoFactorAuthService.serviceFail || 'There is an error processing your request at this time. Please try
            again later.'}}</p>
        </div>
      </div>
    </div>
    <ng-template #nonErrorBlock>
    <ng-container *ngIf="hrtFlag && hrtFlag === 'deny'">
      <deny-modal [modalId]="modalId" [contract]="contract" [denyModalTitle]="denyModalTitle" [denyModalMsg]="denyModalMsg"></deny-modal>
    </ng-container>
    <ng-container *ngIf="hrtFlag && hrtFlag === 'prompt'">
        <prompt-modal *ngIf="!twoFactorAuthService.verifyCode" [modalId]="modalId" [contract]="contract" [promptModalTitle]="promptModalTitle" [promptModalMsg]="promptModalMsg"></prompt-modal>
        <verify-code *ngIf="twoFactorAuthService.verifyCode" [modalId]="modalId" [contract]="contract" [verifyCodeTitle]="verifyCodeTitle" [verifyCodeMsg]="verifyCodeMsg"></verify-code>
    </ng-container>
    </ng-template>    
  </ng-template>
  </div>
</pru-modal>